const getApiHost = (env) => {
  if (env === 'dev') {
    return 'https://api.storytelbridge.com/web-runtime-api';
  }
  return `${window.location.origin}/wra`;
};

/**
 * For local development purpose only
 * Returns a header with the user's token found in 'SSO_Token' cookie
 */
const getHeaders = (env) => {
  const headers = new Headers();
  if (env === 'dev') {
    const token = (
      document.cookie.split('; ').find((row) => row.startsWith('SSO_Token=')) || ''
    ).split('=')[1];

    headers.set('X-Storytel-SSO-Token', token || '');
  }

  return headers;
};

module.exports = { getApiHost, getHeaders };
